var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-image"},[_c('div',{staticClass:"section-header"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"image-wrapper"},[(_vm.images.length)?_c('img',{staticClass:"image",attrs:{"src":_vm.images[0]}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }